import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import Match2Scene from './Match2Scene';

export default class Match2PlaytestScene extends Match2Scene {
  constructor() {
    super();

    // Quit button should just finish the game
    this.quit.onClick = async () => {
      this.game?.finish();
    };

    // Cheats can be accessed from the goals panel
    this.goals.onInputStart = () =>
      openPopupPromise('popupMatch2Cheats', {
        gameplay: true,
        editor: false,
      });
  }

  protected async triggerTips() {
    // No tips in editor mode
    return;
  }

  public showScene(): void {
    super.showScene();
    // Quit button always visible in editor mode
    this.quit.show();
  }
}
